import { Form, Input, Row, Col, Spin, message } from "antd";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { GetAddressFinepByCompanyAndType, EditAddressFinep, CreateAddressFinep } from "../../API/AddressFinepAPI";
import { getInfosByCep } from "../../API/CepAPI";
import { CompanyFinepContext } from "../../Contexts/CompanyFinepContext";
import { AddressFinepModel } from "../../Models/AddressFinepModel";
import { useAuth } from "../../Hooks/useAuth";
interface AddressFinepPartial {
    type: 'matrix' | 'branch' | 'correspondence';
    setHasValueInForm?: React.Dispatch<React.SetStateAction<string>>;
    setValidateField: React.Dispatch<React.SetStateAction<boolean>>;
    valueInForm?: string;
}
const AddressFinepPartial = ({ type, valueInForm, setHasValueInForm, setValidateField }: AddressFinepPartial) => {
    const { companyId } = useParams();
    const user = useAuth();
    const { handleFillTab, handleValidateTab } = useContext(CompanyFinepContext);
    const { control, handleSubmit, setValue, watch } = useForm<AddressFinepModel>({
        defaultValues: {
            additionalInfo: '',
            number: '',
            neighborhood: '',
            state: '',
            streetAddress: '',
            zipCode: '',
            city: '',
            addressType: type
        }
    });
    const [loading, setLoading] = useState(false);
    const formValues = watch();
    useEffect(() => {
        getAddress();
    }, []);
    async function getAddress() {
        setLoading(true);
        if (companyId) {
            await GetAddressFinepByCompanyAndType(companyId, type)
                .then(response => {
                    if (response) {
                        handleFillTab(1);
                        if (response?.isContentValid) {
                            handleValidateTab(1, 3);
                            setValidateField(true);
                        }
                        if (setHasValueInForm) setHasValueInForm("1");
                        setValue('id', response.id);
                        setValue('zipCode', response.zipCode || '');
                        setValue('city', response.city || '');
                        setValue('streetAddress', response.streetAddress || '');
                        setValue('state', response.state || '');
                        setValue('neighborhood', response.neighborhood || '');
                        setValue('additionalInfo', response.additionalInfo || '');
                        setValue('number', response.number || '');
                    }
                });
        }
        setLoading(false);
    }
    const onSubmit = async (data: AddressFinepModel) => {
        setLoading(true);
        data.addressType = type;
        data.userEmail = user.userEmail;
        data.companyFinepId = companyId;
        try {
            if (data.id) {
                await EditAddressFinep(data);
                message.success('Endereço atualizado com sucesso!');
            } else {
                handleFillTab(1);
                const response = await CreateAddressFinep(data);
                setValue('id', response.data.id);
                message.success('Endereço criado com sucesso!');
            }
        } catch (error) {
            message.error(data.id ? 'Erro ao atualizar endereço' : 'Erro ao criar endereço');
        } finally {
            setLoading(false);
        }
    };
    const handleCepChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const cep = e.target.value.replace(/\D/g, '');
        setValue('zipCode', cep);
        if (cep.length === 8) {
            setLoading(true);
            try {
                const result = await getInfosByCep(cep);
                if (result?.erro) {
                    message.error('CEP não encontrado');
                    return;
                }
                setValue('city', result.localidade || '');
                setValue('streetAddress', result.logradouro || '');
                setValue('state', result.uf || '');
                setValue('neighborhood', result.bairro || '');
                handleSubmit(onSubmit)();
            } catch (error) {
                message.error('Erro ao buscar CEP');
            } finally {
                setLoading(false);
            }
        }
    };
    return (
        <Spin spinning={loading}>
            <Form
                layout="vertical"
                onFinish={handleSubmit(onSubmit)}
                style={{ display: valueInForm === "1" ? "none" : "block" }}
                className="mb-2 mt-4"
            >
                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item label="CEP:" required>
                            <Input
                                placeholder="Digite o CEP (apenas números)"
                                value={formValues.zipCode || ''}
                                onChange={handleCepChange}
                                maxLength={8}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Cidade:">
                            <Input
                                placeholder="Cidade será preenchida automaticamente"
                                disabled
                                value={formValues.city || ''}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Estado:">
                            <Input
                                placeholder="Estado será preenchido automaticamente"
                                disabled
                                value={formValues.state || ''}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Bairro:">
                            <Input
                                placeholder="Digite o bairro"
                                value={formValues.neighborhood || ''}
                                onChange={(e) => setValue('neighborhood', e.target.value)}
                                onBlur={handleSubmit(onSubmit)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Endereço:">
                            <Input
                                placeholder="Digite o endereço"
                                value={formValues.streetAddress || ''}
                                onChange={(e) => setValue('streetAddress', e.target.value)}
                                onBlur={handleSubmit(onSubmit)}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Número:" required>
                            <Input
                                placeholder="Digite o número"
                                value={formValues.number || ''}
                                onChange={(e) => setValue('number', e.target.value)}
                                onBlur={handleSubmit(onSubmit)}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Complemento:">
                            <Input
                                placeholder="Digite o complemento (opcional)"
                                value={formValues.additionalInfo || ''}
                                onChange={(e) => setValue('additionalInfo', e.target.value)}
                                onBlur={handleSubmit(onSubmit)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Spin>
    );
};
export default AddressFinepPartial;